import type { RewardType } from '@common/model_builder/dropdowns/rewardType'
import { useMemo } from 'react'
import type { LogFunctions } from '@/content/services/logger'
import { useRewards } from '@/features/members-area/reward-store/hooks/useRewards'
import { isRewardRedeemable } from '@/features/members-area/reward-store/utils/isRewardRedeemable'

export const useAvailableRewards = (config: { hideRewardTypes: RewardType[] }, logger: LogFunctions) => {
    const { rewards } = useRewards(config)

    return useMemo(() => {
        const redeemableRewards = rewards?.filter(reward => isRewardRedeemable(reward, logger)) ?? []

        return {
            hasRewards: redeemableRewards?.length > 0,
            numberOfRewards: redeemableRewards?.length ?? 0,
        }
    }, [logger, rewards])
}
